/**
 * AB#21973 (Zendesk #9522) — when a mousedown outside the dashboard's
 * right-click menu may close it.
 *
 * The right-click menu (DashboardActions with `showAsMenu`) hosts every form it
 * opens, so closing the menu unmounts the form with it. Its outside-click guard
 * spared the centre-modal shell (.modal-backdrop / .modal-content) but not the
 * drawer shell that AB#21826 moved those forms onto. The first mousedown inside
 * a drawer — on Save, on a product card, anywhere that is not an input or a
 * label — closed the menu and took the drawer with it before the click landed:
 * Copy order vanished on Save and copied nothing.
 *
 * A surface the menu opened, or a popup teleported out of one, is not outside.
 */
export const CONTEXT_MENU_KEEP_OPEN_SELECTOR = [
  // Form controls and the popups they teleport to <body>.
  'input',
  'select',
  'option',
  'textarea',
  'label',
  '.dropdown-menu',
  '.dropdown-option',
  '.urgency-dropdown',
  '.vs__dropdown-option',
  '.dp__menu',
  // Centre-modal shell (Dialog.vue).
  '.modal-backdrop',
  '.modal-content',
  // Drawer shell (Drawer.vue): the panel, and its scrim — a scrim click closes
  // the drawer through its own close event, not by unmounting the menu.
  '.dr',
  '.dr-scrim',
  // Confirms and toasts a form raises on save.
  '.swal2-container',
].join(', ');

export function shouldCloseContextMenu(
  menu: HTMLElement | null,
  target: EventTarget | null
): boolean {
  if (!menu || !(target instanceof Element)) return false;
  if (menu.contains(target)) return false;
  return !target.closest(CONTEXT_MENU_KEEP_OPEN_SELECTOR);
}
